<template>
  <q-btn
    round
    flat
    dense
    :size="btnSizeComp"
    :icon="btnIcon"
    class="color-on-hover default-btn"
  >
    <q-tooltip
      v-model="startShowMe"
      :class="tooltipContentClass"
      self="center left"
      :offset="tooltipOffset"
    >
      <div :style="tooltipMainDivStyle">
        <slot name="header"></slot>
        <div
          v-if="tooltipTitle"
          class="tooltip-default ibf-h8"
        >
          {{ tooltipTitle }}
        </div>
        <q-separator
          v-if="tooltipTitleTextSeparator"
          class="tooltip-seperator"
        />
        <div
          v-if="tooltipBodyText"
          :class="tooltipBodyTextClassComp"
        >
          {{ tooltipBodyText }}
        </div>
        <slot name="body"></slot>
        <div
          v-if="tooltipFooterText"
          :class="tooltipFooterTextClassComp"
        >
          {{ tooltipFooterText }}
        </div>
        <slot name="footer"></slot>
      </div>
    </q-tooltip>
  </q-btn>
</template>

<script>
export default {
  name: 'IbTooltipBtn',
  props: {
    showme: {
      type: Boolean,
      default: false,
    },
    btnIcon: {
      type: String,
      default: 'icon-question-circle', // icon-warning-filled-off
    },
    btnSize: {
      type: Number,
      default: 6,
    },
    tooltipOffset: {
      default() {
        return [-40, 10];
      },
    },
    tooltipContentClass: {
      type: String,
      default: 'tooltip-background',
    },
    tooltipTitle: {
      type: String,
    },

    tooltipTitleTextSeparator: {
      type: Boolean,
      default: false,
    },
    tooltipBodyText: {
      type: String,
    },
    tooltipBodyTextClass: {
      type: String,
      default: '',
    },
    tooltipFooterText: {
      type: String,
    },
    tooltipFooterTextClass: {
      type: String,
      default: '',
    },
    tooltipWidth: {
      default: 0,
    },
  },
  data() {
    return {
      startShowMe: false,
    };
  },
  computed: {
    btnSizeComp() {
      return `${this.btnSize}px`;
    },

    tooltipBodyTextClassComp() {
      if (!this.tooltipBodyTextClass) return 'body-margin ibf-caption1 app_text_grey';
      return this.tooltipBodyTextClass;
    },
    tooltipFooterTextClassComp() {
      if (!this.tooltipFooterTextClass) return 'footer-margin-bottom ibf-caption1 app-text-white';
      return this.tooltipFooterTextClass;
    },
    tooltipMainDivStyle() {
      if (this.tooltipWidth) return `width: ${this.tooltipWidth}px; `;
      return '';
    },
  },
  mounted() {
    if (this.showme) this.startShowMe = this.showme;
  },
};
</script>

<style lang="scss" scoped>
.color-on-hover {
  :deep(i:before) {
    font-size: 14px;
    color: $-text-text-low-old;
  }
  &:hover {
    :deep(i:before) {
      color: $-text-text-primary;
    }
  }
}
.body-margin {
  margin-top: 8px;
  margin-bottom: 8px;
}
.footer-margin {
  margin-top: 4px;
  margin-bottom: 4px;
}
.footer-margin-bottom {
  margin-bottom: 4px;
}
.default-btn {
  margin-top: auto;
  margin-bottom: auto;
  height: 14px;
}
</style>
